import type { ReactElement } from 'react';
import { CookiesProvider } from 'react-cookie';
import { ToastNotification } from '@/components/molecules';
import { ToastNotificationProvider } from '@/contexts/toast-notification/ToastNotificationContext';
import { StudentContextProvider } from '@/contexts/index';
import Routes from '@/routes/Routes';
import cookies from './infrastructures/cookies';

function App(): ReactElement {
  return (
    <CookiesProvider cookies={cookies}>
      <ToastNotificationProvider>
        <StudentContextProvider>
          <Routes />
          <ToastNotification />
        </StudentContextProvider>
      </ToastNotificationProvider>
    </CookiesProvider>
  );
}

export default App;
